<template>
  <div class="center_box">
    <Header style="margin-top:30px;"></Header>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <router-link to="/">{{$t('message.homepage')}}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.product')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.title_01')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div><h1 style="font-size:34px;padding-top:20px;padding-bottom:20px;">{{$t('message.title_01')}}</h1></div>
    <SelectedMotor v-on:listenPageChange="listenPageChange" v-show="MotorPage" v-on:listenParam="listenParam"></SelectedMotor>
    <SelectedDeceleration v-on:listenPageChange="listenPageChange" v-show="DecelerationPage" v-on:listenParam="listenParam"></SelectedDeceleration>
    <SelectedMachineSize ref="SelectedMachineSize" v-on:listenPageChange="listenPageChange" v-show="MachineSizePage" v-on:listenParam_1="listenParam_1" :param_1="param_1"></SelectedMachineSize>
    <SelectedCompleted ref="SelectedCompleted" v-on:listenPageChange="listenPageChange" v-show="CompletedPage" :param_1="param_1" :param_2="param_2"></SelectedCompleted>
    <BackTop></BackTop>
  </div>
</template>
<script>
import Header from '../Header'
import BackTop from '../BackTop'
import SelectedMotor from './SelectedMotor'
import SelectedDeceleration from './SelectedDeceleration'
import SelectedMachineSize from './SelectedMachineSize'
import SelectedCompleted from './SelectedCompleted'
export default {
  name: 'ElectricMachine',
  components: {
    SelectedMotor,
    SelectedDeceleration,
    SelectedMachineSize,
    SelectedCompleted,
    BackTop,
    Header
  },
  data () {
    return {
      MotorPage : true,
      DecelerationPage : false,
      MachineSizePage : false,
      CompletedPage : false,
      param_1 : {},
      param_2 : {}
    }
  },
  methods:{
    // 监听页面跳转
    listenPageChange:function(data) {
      if(data === 'to_DecelerationPage'){
        this.MachineSizePage = false
        this.MotorPage = false
        this.DecelerationPage = true
        this.CompletedPage = false
      }else if(data === 'to_MachineSize'){
        //调用子组件方法
        this.$refs.SelectedMachineSize._getlistbyseriesandmotor();
        this.MachineSizePage = true
        this.MotorPage = false
        this.DecelerationPage = false
        this.CompletedPage = false
      }else if(data === 'to_CompletedPage'){
        //调用子组件方法
        this.$refs.SelectedCompleted._getinfobyreducersize();
        this.$refs.SelectedCompleted._getinfobyfactoryandsize();
        this.MachineSizePage = false
        this.MotorPage = false
        this.DecelerationPage = false
        this.CompletedPage = true
      }else if(data === 'to_Motor'){
        this.MachineSizePage = false
        this.MotorPage = true
        this.DecelerationPage = false
        this.CompletedPage = false
      }
    },
    // 电机 减速比 监听参数传递
    listenParam:function(data) {
      if(data.motor_factory || data.motor_type){
        this.param_1.motor_factory = data.motor_factory;
        this.param_1.motor_type = data.motor_type;
      }else if(data.motor_reducer || data.motor_ratio){
        this.param_1.reducer_series_name = data.motor_reducer;
        this.param_1.reduction_ratio = data.motor_ratio;
      }
    },
    // 减速机型号 监听参数传递
    listenParam_1:function(data) {
      this.param_2.reducer_size = data.name;
    }
  }
}
</script>
<style scoped>
  .center_box {
    width:75%;
    margin:0 auto;
    height:100%;
  }
  .el-breadcrumb {
    font-size: 18px;
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectricMachine/ElectricMachine.vue